import React, { useMemo } from 'react'
import useStyles from './styles'

import { userHasPurchasedTicket as getUserHasPurchasedTicket } from 'redux/slices/passes'

import { getShowHasStarted, isPaywallDisabled } from 'redux/slices/liveShow'
import { showHasEnded } from 'utils/show'
import InfoBar from 'components/set/InfoBar/InfoBar'
import InteractionPlayer from 'components/set/InteractionPlayer/InteractionPlayer'
import InteractionWidgetWrapper from 'components/set/InteractionWidgetWrapper/InteractionWidgetWrapper'
import LuaContainer from 'components/set/LuaContainer/LuaContainer'
import ErrorBoundary from 'components/common/ErrorBoundary/ErrorBoundary'
import MessagingBanner from 'components/set/MessagingBanner/MessagingBanner'
import Curtain from 'components/set/Curtain/Curtain'
import clsx from 'clsx'
import { useSelector } from 'react-redux'
import WidgetContainer from 'components/set/WidgetContainer/WidgetContainer'
import AccessCodeForm from 'components/set/AccessCodeForm/AccessCodeForm'
import { isSmartTV } from 'utils'
import { isCurtainClosed } from 'utils/curtain'
import { getCurtainValue } from 'redux/slices/curtain'
import { isModalOpen } from 'redux/slices/globalModal'
import Navigation from 'components/common/Navigation/Navigation'
import { isMobile } from 'utils'
import CoverImage from 'components/common/CoverImage/CoverImage'
import { ScopeType } from 'data/Show'
import JoinEventForm from 'components/set/JoinEventForm/JoinEventForm'

const Event = ({ show }) => {
    const classes = useStyles()

    const curtainValue = useSelector(getCurtainValue)
    const showHasStarted = useSelector(getShowHasStarted)
    const paywallDisabled = useSelector(isPaywallDisabled)
    const userHasPurchasedTicket = useSelector(getUserHasPurchasedTicket)
    const modalOpen = useSelector(isModalOpen)

    const shouldRenderAccessCodeForm = useMemo(() => show.scope === ScopeType.PRIVATE && !userHasPurchasedTicket, [
        show.scope,
        userHasPurchasedTicket,
    ])

    const shouldRenderJoinAccessForm = useMemo(
        () => show.scope === ScopeType.PUBLIC && paywallDisabled && !userHasPurchasedTicket,
        [show.scope, paywallDisabled, userHasPurchasedTicket],
    )

    const curtainClosed = useMemo(() => isCurtainClosed(curtainValue), [curtainValue])
    const showBanner = useMemo(() => !showHasStarted || showHasEnded(show) || !userHasPurchasedTicket, [
        show,
        showHasStarted,
        userHasPurchasedTicket,
    ])

    if (shouldRenderJoinAccessForm) {
        return (
            <JoinEventForm title={show.title} cover={show.coverImgUrl} showId={show._id} posterImg={show.posterImg} />
        )
    }

    if (shouldRenderAccessCodeForm) {
        return <AccessCodeForm title={show.title} cover={show.coverImgUrl} showId={show._id} />
    }

    return (
        <div
            className={clsx(classes.container, {
                [classes.smartTv]: isSmartTV,
                [classes.notTv]: !isSmartTV,
                [classes.hide]: modalOpen && isSmartTV,
            })}
        >
            <Navigation transparent position={isMobile() ? 'absolute' : 'fixed'} />

            <CoverImage imgSrc={show.coverImgUrl} />

            <div className={classes.content}>
                {showBanner && <MessagingBanner />}

                <div className={classes.contentWrapper}>
                    <div className={clsx(classes.liveContent, showBanner && classes.hasBanner)}>
                        <div className={clsx(curtainClosed && classes.hide)}>
                            <ErrorBoundary name="Interaction Player">
                                <InteractionPlayer />
                            </ErrorBoundary>
                            {!isSmartTV && (
                                <>
                                    <InfoBar />
                                    <WidgetContainer hideInMobile />
                                </>
                            )}
                        </div>

                        <Curtain />
                    </div>
                    <div className={clsx(classes.interactionWidget, showBanner && classes.hasBanner)}>
                        <ErrorBoundary name="Interaction Widget">
                            <InteractionWidgetWrapper />
                            <LuaContainer />
                        </ErrorBoundary>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default React.memo(Event)
